<template>
    <div class="tnc-wrapper">
        <h2><span style="font-size: 16pt">শর্তাবলী</span></h2>
        <h4>
            <strong><span style="font-size: 12pt">সাধারণ নিয়ম</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">আমাদের ওয়েবসাইটটি কেবলমাত্র সেই ব্যক্তির জন্য সীমাবদ্ধ যা তার
                        বসবাসের এখতিয়ার অনুসারে আইনি বয়সের।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">আমাদের ওয়েবসাইট ব্যবহারকারী কোনও ব্যবহারকারীর দ্বারা লঙ্ঘিত কোনও
                        জাতীয় আইন, ফেডারেল আইন বা আন্তর্জাতিক আইনের জন্য আমাদের ওয়েবসাইট কোনও দায়বদ্ধতা রাখে
                        না।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ব্যবহারকারীরা তাদের নিজস্ব কর্মকাণ্ডের জন্য দায়ী এবং তাদের নিজস্ব
                        দেশের আইন দ্বারা আবদ্ধ, যার মধ্যে রাষ্ট্রীয় আইন বা আইনি সমস্যা অন্তর্ভুক্ত।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">সকল এজেন্ট তাদের নিজ নিজ সদস্যদের অ্যাকাউন্টের জন্য দায়ী, এবং তাদের
                        দ্বারা জমা দেওয়া সমস্ত নিশ্চিত বাজি সম্মান করবে।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">এজেন্টরা আমাদের ওয়েবসাইটের অংশীদার নয়। অতএব, খেলোয়াড় এবং
                        এজেন্টদের মধ্যে কোনও অসঙ্গতি বা বিরোধের জন্য আমাদের ওয়েবসাইট কোনও দায়বদ্ধতা রাখে না।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ব্যবহারকারীর দায়িত্ব হলো তার ইউজার আইডি এবং পাসওয়ার্ড অননুমোদিত
                        ব্যবহার থেকে রক্ষা করা। যদি ব্যবহারকারীর ইউজার আইডি এবং পাসওয়ার্ড চুরি হয়ে যায় বা হ্যাক হয়ে
                        যায়, তাহলে অবিলম্বে তার এজেন্টের সাথে যোগাযোগ করা ব্যবহারকারীর দায়িত্ব। এরপর এজেন্ট তার জন্য
                        ব্যবহারকারীর ইউজার আইডি এবং পাসওয়ার্ড পরিবর্তন করবে।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ব্যবহারকারীর আইডি এবং পাসওয়ার্ড চুরি হয়ে গেলে, ব্যবহারকারী তাদের
                        নিজ নিজ অ্যাকাউন্টের জন্য দায়ী থাকবেন এবং জমা দেওয়া সমস্ত নিশ্চিত বাজি মেনে চলবেন।</span>
                </p>
            </li>
        </ol>
        <h4>
            <strong><span style="font-size: 12pt">গেমিং নিয়ম</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p><span style="font-size: 10.5pt">আমাদের ওয়েবসাইট কর্তৃক নির্ধারিত খেলার ফলাফল চূড়ান্ত এবং
                        বাধ্যতামূলক হবে।</span></p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">সকল বিরোধের ক্ষেত্রে, আমাদের ওয়েবসাইটের ব্যবস্থাপনা এবং খেলোয়াড়
                        উভয়কেই একমত হতে হবে যে আমাদের ওয়েবসাইটের লেনদেন লগ ডাটাবেস বিরোধের চূড়ান্ত বিচারক হিসেবে কাজ
                        করবে। সমস্ত বিরোধ ম্যাচের ফলাফল নির্ধারিত হওয়ার দিনের মধ্যে দায়ের করতে হবে। ম্যাচের দিনের পরে
                        কোনও দাবি গ্রহণ করা হবে না।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">খেলোয়াড় তাদের সমস্ত অ্যাকাউন্ট লেনদেনের নির্ভুলতা যাচাই করার জন্য
                        সম্পূর্ণরূপে দায়ী।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">কম্পিউটারের মাধ্যমে জমা দেওয়ার আগে আপনার বাজিতে কোনও ভুল, ত্রুটি বা
                        বাদ পড়ার জন্য দয়া করে পর্যালোচনা করুন। একবার কম্পিউটারের মাধ্যমে বাজি গৃহীত হলে, এটি পরিবর্তন
                        বা বাতিল করা যাবে না।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">এই শর্তাবলী লঙ্ঘন, প্রতারণামূলক কার্যকলাপে জড়িত, অনুপ্রবেশ, আক্রমণ,
                        জালিয়াতি, স্ট্যান্ডার্ড নিয়ম লঙ্ঘন, অথবা সিন্ডিকেট বাজি ধরার সাথে জড়িত থাকার অভিযোগে পাওয়া
                        গেলে আমরা যেকোনো গ্রাহকের অ্যাকাউন্ট ফ্রিজ বা বাতিল করার অধিকার সংরক্ষণ করি, যার ফলে পূর্ব নোটিশ
                        ছাড়াই সমস্ত অ্যাকাউন্ট ব্যালেন্স ফ্রিজ এবং বাজেয়াপ্ত করা হবে।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">আমরা এমন যেকোনো বাজি বা বেটিং টিকিট বাতিল বা অকার্যকর করার অধিকার
                        সংরক্ষণ করি, যা সিন্ডিকেট বেটিং, সমন্বিত বেটিং, যোগসাজশ, প্রতারণা, সিস্টেমের অপব্যবহার,
                        প্রযুক্তিগত ত্রুটি বা ভুল অডসের সুযোগ নেওয়া, অথবা অন্য কোনো উপায়ে অন্যায্য সুবিধা অর্জনের
                        প্রচেষ্টার সঙ্গে সম্পর্কিত বলে প্রমাণিত হয়। সংশ্লিষ্ট যেকোনো জয়ের অর্থ বাতিল বা ফেরত নেওয়া
                        হতে পারে এবং সংশ্লিষ্ট অ্যাকাউন্ট সাময়িকভাবে স্থগিত বা স্থায়ীভাবে বন্ধ করা হতে পারে।</span>
                </p>
            </li>
        </ol>
        <h4>
            <strong><span style="font-size: 12pt">সীমা এবং দায়বদ্ধতা</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">পূর্বোক্ত বিষয়গুলির সামগ্রিকতার সাথে কোনও বিরূপ আচরণ না করে, আমাদের
                        ওয়েবসাইট কোনও ব্যক্তির কাছে নাশকতা, বলপ্রয়োগের ঘটনা, এবং/অথবা আমাদের ওয়েবসাইটের কেন্দ্রীয়
                        কম্পিউটার সিস্টেম বা রেকর্ড বা এর কোনও অংশের ব্যর্থতা বা ক্ষতি বা ধ্বংসের ঘটনা, অথবা কোনও
                        টেলিযোগাযোগ বা কোনও ডেটা ট্রান্সমিশন সিস্টেমের ব্যর্থতার ফলে বিলম্ব, ক্ষতি, ত্রুটি, বাদ পড়া বা
                        এর অন্য কোনও ঘটনার জন্য, অথবা কোনও নির্দিষ্ট জাতির জন্য কোনও এন্ট্রি না পাওয়ার কারণে কোনও
                        বিলম্বের জন্য দায়ী থাকবে না।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">আমাদের ওয়েবসাইট ঈশ্বরের কোনও কাজের ফলে, শত্রুতা, দাঙ্গা, নাগরিক
                        অস্থিরতা, সন্ত্রাসবাদ, সরকার বা কর্তৃপক্ষের কোনও কার্যকলাপ (যে কোনও লাইসেন্স বা সম্মতি
                        প্রত্যাখ্যান বা বাতিল সহ), অগ্নিকাণ্ড, বন্যা, চুরি, দূষিত ক্ষতি, ধর্মঘট, লক-আউট এবং যেকোনো ধরণের
                        শিল্প কর্মকাণ্ডের ফলে কোনও ক্ষতির জন্য দায়ী থাকবে না।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">নেটওয়ার্ক সংযোগ, যোগাযোগ, সিস্টেম বা মানুষের ত্রুটির কারণে বাজি
                        সম্পর্কিত সমস্যা দেখা দিলে যেমন ডাবল বাজি গ্রহণ করা, বাজি নিশ্চিত করা না যাওয়া, খেলা শুরু
                        হওয়ার পরে বাজি ধরা ইত্যাদি। এই ধরনের ত্রুটির ক্ষেত্রে আমরা কেস-টু-কেস ভিত্তিতে এটি সমাধান করার
                        এবং এই ধরনের ত্রুটি সংশোধন করার জন্য অন্য কোনও পদক্ষেপ নেওয়ার অধিকার সংরক্ষণ করি। এই ধরনের
                        ত্রুটির ক্ষেত্রে আপনার বা কোনও তৃতীয় পক্ষের কাছে আমাদের কোনও দায় থাকবে না। যদি আপনি এই ধরনের
                        ত্রুটির সম্মুখীন হয়ে থাকেন এবং আপনার আপলাইনে রিপোর্ট না করে বাজি ধরে থাকেন, তাহলে আপনি দায়ী
                        থাকবেন এবং ত্রুটিগুলি আবার ঘটলে সমস্ত জয়/পরাজয়ের ফলাফলকে সম্মান করবেন।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">এই নিয়মকানুনগুলি পক্ষগুলির মধ্যে সম্পূর্ণ চুক্তি এবং সমঝোতা গঠন
                        করে।</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">যদি এই নিয়ম ও প্রবিধানের ইংরেজি ভাষার সংস্করণ এবং অন্য কোনও ভাষার
                        সংস্করণের মধ্যে কোনও অসঙ্গতি থাকে, তাহলে ইংরেজি ভাষার সংস্করণটি অন্যান্য ভাষার চেয়ে বেশি
                        কার্যকর হবে এবং সঠিক এবং বৈধ বলে বিবেচিত হবে।</span>
                </p>
            </li>
        </ol>
        <BurgerMenu v-if="isMobile" />
    </div>
</template>
<script>
    import BurgerMenu from '@/components/burger-menu.vue';
    import { isMobile } from 'mobile-device-detect';
    export default {
        components: {
            BurgerMenu,
        },
        data: () => {
            return {
                isMobile,
            };
        },
    };
</script>
<style lang="scss" scoped>
    .tnc-wrapper {
        padding: 16px 24px;
        box-sizing: border-box;
        height: calc(100% - 56px);
        overflow-y: auto;
    }

    strong,
    h2,
    h4 {
        font-weight: 600;
    }
</style>
